import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Grid,
  TextField,
  DialogActions,
  IconButton,
  CircularProgress,
} from '@mui/material';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { AlertMessagesContext } from 'react-alert-messages';
import StockReportService from 'services/StockReportService';

export default function EditStockConsumptionDialog({ open, handleClose, handleSuccess, stockLog }) {
  const { t: tCommon } = useTranslation('common');
  const { postAlertMessage } = useContext(AlertMessagesContext);

  const [quantity, setQuantity] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && stockLog) {
      setQuantity(String(Math.abs(stockLog.quantity || 0)));
    } else {
      setQuantity('');
    }
  }, [open, stockLog]);

  if (!open || !stockLog) return null;

  const handleSave = async () => {
    if (quantity === '' || isNaN(Number(quantity)) || Number(quantity) < 0) {
      postAlertMessage({
        text: tCommon('Please enter a valid quantity'),
        type: 'failed',
      });
      return;
    }

    setSaving(true);
    try {
      const payload = {
        quantity: -Number(quantity),
      };
      await StockReportService.updateStockLog(stockLog.id, payload);
      postAlertMessage({ text: tCommon('Consumption updated successfully'), type: 'success' });
      handleSuccess();
      handleClose();
    } catch (err) {
      postAlertMessage({ text: err.message || 'Failed to update consumption', type: 'failed' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper} style={{ width: '40%', maxWidth: '500px' }}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Edit Stock Consumption')}</h2>
          <IconButton size="medium" onClick={handleClose} disabled={saving}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={styles.inputSec} style={{ padding: '24px' }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                label={tCommon('Item Name')}
                value={stockLog.item?.name || ''}
                variant="outlined"
                size="small"
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={tCommon('PLU')}
                value={stockLog.item?.plu || ''}
                variant="outlined"
                size="small"
                fullWidth
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                type="number"
                label={tCommon('Quantity')}
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                variant="outlined"
                size="small"
                fullWidth
                inputProps={{ min: 0 }}
                autoFocus
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button
              onClick={handleClose}
              variant="contained"
              color="secondary"
              className={styles.closeBtn}
              disabled={saving}
            >
              {tCommon('Cancel')}
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              color="primary"
              style={{ backgroundColor: '#00a65a' }}
              disabled={saving || quantity === ''}
            >
              {saving ? <CircularProgress size={20} color="inherit" /> : tCommon('Save')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}
